'use client';

import { useMutation } from '@tanstack/react-query';
import { globalScannerApi } from './global-scanner.api';

export function useQrResolveMutation() {
  return useMutation({
    mutationFn: (code: string) => globalScannerApi.resolve(code)
  });
}
